import React from 'react'
import Img1 from "../img/pattern_design/1.jpg";
import Img2 from "../img/pattern_design/2.jpg";
import Img3 from "../img/pattern_design/3.jpg";
import Img4 from "../img/pattern_design/4.jpg";
import Img5 from "../img/pattern_design/5.jpg";
import Img6 from "../img/pattern_design/6.jpg";




export default function PatternDesign() {
 
  return (
    <>
    <section id="industry" className="services">
      <div className="container" style={{opacity: "1",paddingBottom: "20px"}}>
        <div className="section-title">
          <h3>Pattern Design</h3>
        </div>
        <div className="row">
          <div className="col-lg-3 col-md-12 mb-4 mb-lg-0">
            <img
              src={Img1}
              className="w-100 shadow-1-strong rounded mb-4"
              style={{padding: "30px"}}
              alt=""
            />
          </div>

          <div className="col-lg-3 col-md-12 mb-4 mb-lg-0">
            <img
              src={Img2}
              className="w-100 shadow-1-strong rounded mb-4"
              style={{padding: "30px"}}
              alt=""
            />
          </div>

          <div className="col-lg-3 col-md-12 mb-4 mb-lg-0">
            <img
              src={Img3}
              className="w-100 shadow-1-strong rounded mb-4"
              style={{padding: "30px"}}
              alt=""
            />
          </div>

          <div className="col-lg-3 col-md-12 mb-4 mb-lg-0">
            <img
              src={Img4}
              className="w-100 shadow-1-strong rounded mb-4"
              style={{padding: "30px"}}
              alt=""
            />
          </div>

          <div className="col-lg-3 col-md-12 mb-4 mb-lg-0">
            <img
              src={Img5}
              className="w-100 shadow-1-strong rounded mb-4"
              style={{padding: "30px"}}
              alt=""
            />
          </div>

          <div className="col-lg-3 col-md-12 mb-4 mb-lg-0">
            <img
              src={Img6}
              className="w-100 shadow-1-strong rounded mb-4"
              style={{padding: "30px"}}
              alt=""
            />
          </div>

          <div className="col-lg-3 col-md-12 mb-4 mb-lg-0">
            <img
              src={Img2}
              className="w-100 shadow-1-strong rounded mb-4"
              style={{padding: "30px"}}
              alt=""
            />
          </div>

          <div className="col-lg-3 col-md-12 mb-4 mb-lg-0">
            <img
              src={Img5}
              className="w-100 shadow-1-strong rounded mb-4"
              style={{padding: "30px"}}
              alt=""
            />
          </div>

        </div>
      </div>
    </section>
    </>
  )
}
